import { FC, useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import ScrollToTopButton from "../../../../../shared/components/molecules/commons/scroll-to-top-button";
import { notificationService } from "../../../../../shared/services/notification-service";
import { AxiosError } from "axios/index";
import { RegistrationPersonnelHistoryService } from "../../../../../shared/services/Report/RegistrationPersonnelHistory/registration-personnel-history";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import TableHeaderOrdering, {
  Header,
} from "../../../../../shared/components/table-header-ordering";
import TableRowNoData from "../../../../../shared/components/molecules/commons/table-row-no-data";

const headers: Header[] = [
  {
    label: "หลักสูตร",
    field: "",
    order: null,
    isOrder: false,
  },
  {
    label: "ประเภทการฝึกอบรม",
    field: "",
    order: null,
    isOrder: false,
  },
  {
    label: "ปี",
    field: "",
    order: null,
    isOrder: false,
  },
  {
    label: "สถาบัน / ประเทศ",
    field: "",
    order: null,
    isOrder: false,
  },
];

const PersonnelTraining: FC = () => {
  let { id } = useParams();
  const [data, setData] = useState<any>([]);

  const fetchData = async () => {
    try {
      const result =
        await RegistrationPersonnelHistoryService.getReportPersonnelHistoryDetail(
          { id: id }
        );
      setData(result);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification(
        "โหลดข้อมูลไม่สำเร็จ",
        err.message
      );
    }
  };

  const tableRowNoData = () => {
    if (data.training_histories?.length === 0) {
      return <TableRowNoData colspan={headers.length} />;
    }
    return null;
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Accordion className="mt-3">
        <Accordion.Item eventKey="0">
          <Accordion.Header className={`text-mof-primary`}>
            <h5 className="text-mof-primary m-0">ประวัติการฝึกอบรม</h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="overflow-auto mt-3">
              <Table bordered>
                <thead>
                  <TableHeaderOrdering
                    headers={headers}
                    onChangeOrder={() => {}}
                    isShow={true}
                  />
                </thead>
                <tbody>
                  {data.training_histories?.map((data: any, index: any) => {
                    return (
                      <tr key={index}>
                        <td>{data.course ? data.course : "-"}</td>
                        <td>{data.course_type ? data.course_type : "-"}</td>
                        <td>{data.year ? data.year : "-"}</td>
                        <td>{data.location ? data.location : "-"}</td>
                      </tr>
                    );
                  })}
                  {tableRowNoData()}
                </tbody>
              </Table>
            </div>

            <div className="mt-3">
              <ScrollToTopButton />
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default PersonnelTraining;
